export default __webpack_public_path__ + "wrist.ce9f3e47.png";